import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SettingsSavedNotice from "./components/SettingsSavedNotice";
import { useAuth } from "./authContext";

export default function ForgotPasswordView() {
  const { requestPasswordReset } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [devUrl, setDevUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!notice) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => setNotice(""), 3600);
    return () => window.clearTimeout(timeoutId);
  }, [notice]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setNotice("");
    setDevUrl("");
    setIsSubmitting(true);

    try {
      const payload = await requestPasswordReset(identifier);
      setNotice("If the account exists, a password reset link has been prepared.");
      setDevUrl(payload?.reset?.url || "");
    } catch (submitError) {
      setError(submitError.message || "Could not start password reset.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="account-shell">
        <section className="account-settings-panel" style={{ maxWidth: "760px", margin: "0 auto" }}>
        <div className="account-page-header">
          <div>
            <h1 className="account-page-title">Forgot Password</h1>
            <p className="account-copy">Request a password reset link for your username or email.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: "grid", gap: "16px" }}>
          <label style={{ display: "grid", gap: "8px", color: "#334155", fontWeight: 700 }}>
            Username or email
            <input
              type="text"
              value={identifier}
              onChange={(event) => setIdentifier(event.target.value)}
              autoComplete="username"
              style={{ height: "46px", borderRadius: "14px", border: "1px solid #cbd5e1", padding: "0 14px", fontSize: "14px" }}
            />
          </label>

          {error ? <div className="account-error" style={{ margin: 0 }}>{error}</div> : null}
          {devUrl ? (
            <div className="account-notice" style={{ margin: 0 }}>
              Development reset link: <a href={devUrl}>{devUrl}</a>
            </div>
          ) : null}

          <div className="account-save-row" style={{ justifyContent: "space-between", alignItems: "center" }}>
            <Link to="/auth" style={{ color: "#0f766e", fontWeight: 700, textDecoration: "none" }}>Back to login</Link>
            <button type="submit" className="account-action-button" disabled={isSubmitting}>
              {isSubmitting ? "Working..." : "Send reset link"}
            </button>
          </div>
        </form>
      </section>
      </div>

      {notice ? <SettingsSavedNotice message={notice} /> : null}
    </>
  );
}